import { useUser } from '@reverbdotcom/commons/src/user_hooks';

export function useFiveDigitLocale() {
  const { locale, countryCode } = { locale: 'en', countryCode: 'US', ...useUser() };

  return [locale, countryCode].join('_');
}
